import type { ReactNode } from "react";

import { AuthFooter } from "@shared/components/AuthFooter/AuthFooter";
import { AuthHeader } from "@shared/components/AuthHeader/AuthHeader";
import { AuthHeaderWrapper } from "@shared/components/AuthHeaderWrapper/AuthHeaderWrapper";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import { CountrySelect } from "@unauthenticated/signupSignin/components/CountrySelect/CountrySelect";
import { Page } from "@unauthenticated/signupSignin/components/Page/Page";
import { PageContent } from "@unauthenticated/signupSignin/components/PageContent/PageContent";

import * as styles from "./SignInLayout.styles";

interface Props {
  children: ReactNode;
  isFullBleed?: boolean;
}

const SignInLayout = ({ children, isFullBleed }: Props) => {
  const { isEmerson } = useSharedGlobalConfig();
  const { tablet } = useBreakpoints();
  const route = isEmerson ? authRoutes.emerson.login : authRoutes.login;
  const isFullBleedDesktop = isFullBleed && tablet.greaterThan;
  const isFullBleedMobile = isFullBleed && !tablet.greaterThan;

  const renderHeader = () => {
    if (isFullBleedDesktop) return null;

    if (isFullBleedMobile) {
      return (
        <div css={styles.mobileHeader}>
          <AuthHeader route={route} />
        </div>
      );
    }

    return (
      <AuthHeaderWrapper>
        <AuthHeader route={route} />
        {!isEmerson && <CountrySelect />}
      </AuthHeaderWrapper>
    );
  };

  return (
    <Page>
      <PageContent customStyles={isFullBleedDesktop ? styles.fullBleedContainer : undefined}>
        {isFullBleedMobile && !isEmerson ? (
          <div css={styles.mobileCountrySelectRow}>
            <CountrySelect />
          </div>
        ) : null}
        {renderHeader()}
        {children}
      </PageContent>
      <AuthFooter css={isFullBleedDesktop ? styles.fullBleedFooter : undefined} />
    </Page>
  );
};

export { SignInLayout };
